import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, galleryImages } from '../../data/companyData';

export default class ProjectThree extends React.Component {
    componentDidMount() {

        const $ = window.$;
        
        if ($(".project-three__carousel").length) {
            $(".project-three__carousel").owlCarousel({
              loop: true,
              margin: 10,
              nav: false,
              smartSpeed: 500,
              autoHeight: false,
              autoplay: true,
              dots: false,
              autoplayTimeout: 6000,
              navText: [
                '<i className="fa fa-angle-double-left" aria-hidden="true"></i>',
                '<i className="fa fa-angle-double-right" aria-hidden="true"></i>',
              ],
              responsive: {
                0: {
                  items: 1,
                },
                600: {
                  items: 1,
                },
                750: {
                  items: 2,
                },
                1100: {
                  items: 3,
                },
                1350: {
                  items: 4,
                },
              },
            });
          }

          if ($(".img-popup").length) {
            var groups = {};
            $(".img-popup").each(function () {
              var id = parseInt($(this).attr("data-group"), 10);
        
              if (!groups[id]) {
                groups[id] = [];
              }
        
              groups[id].push(this);
            });
        
            $.each(groups, function () {
              $(this).magnificPopup({
                type: "image",
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: {
                  enabled: true,
                },
              });
            });
          }
          
    }
    render(){
        const featured = galleryImages.slice(0, 6);
        return (
            <>
                <section className="project-three">
                    <div className="container-fluid">
                        <div className="sec-title text-center">
                            <div className="sec-title__tagline">
                                <span className="left"></span>
                                <h6>GALLERY</h6> <span className="right"></span>
                            </div>
                            <h2 className="sec-title__title">Recent interior trim and <br /> remodeling work.</h2>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="project-three__carousel owl-carousel owl-theme">
                                    {featured.map((item) => (
                                        <div className="project-three__single" key={item.src}>
                                            <div className="project-three__single-img">
                                                <img src={assetPath(item.src)} alt={item.title} />
                                                <div className="icon-box">
                                                    <a className="img-popup" href={assetPath(item.src)}><span
                                                            className="icon-plus-sign"></span></a>
                                                </div>
                                                <div className="content-box">
                                                    <p>{item.category}</p>
                                                    <h3><Link to={process.env.PUBLIC_URL + `/gallery`}>{item.title}</Link></h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <div className="project-three-more-project-btn text-center">
                                    <div className="btn-box">
                                        <Link to="/gallery" className="thm-btn" data-text="View Gallery +">View Gallery +</Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </>
        )
    }
}
